import PropTypes from 'prop-types';
import React from 'react';

import { Dispatcher as IconDispatcher } from '$partials/icon';
import {
    Player,
    PlayerEmbed,
    PlayerPlaceholder,
    PlayerPlayButton
} from '$partials/base/player.jsx';
import { useLanguage } from '$contexts/language.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Video = ({
    caption     = null,
    posterImage = null,
    video       = null
}) => {
    // hooks
    const { translate: t } = useLanguage();

    // render
    return (
        <section className='module-video'>
            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                <div className='flex flex-wrap'>
                    {/* side title */}
                    <div className='absolute top-0 md-relative md-col-2' />

                    {/* content */}
                    <div className='col-12 sm-col-12 md-col-10'>
                        <div className='ml9 sm-ml9 md-ml0'>
                            <div className='px-gutter'>
                                {video.html && (
                                    <figure>
                                        <div className='font-0 border-rad-10'>
                                            <Player
                                                className='width-100 line-height-0 relative'
                                                shouldPrerender={true}
                                                shouldToggleVisibility={true}>
                                                <PlayerEmbed>
                                                    <div
                                                        className='video-oembed'
                                                        dangerouslySetInnerHTML={{ __html: video.html }}
                                                        style={{ paddingBottom: `${((video.height/video.width)* 100)}%` }} />
                                                </PlayerEmbed>

                                                <PlayerPlaceholder className='expand-interaction relative'>
                                                    {(posterImage?.px2 || video.thumbnailUrl) && (
                                                        <img
                                                            className='width-100'
                                                            height={video.height}
                                                            loading='lazy'
                                                            src={posterImage?.px2 || video.thumbnailUrl}
                                                            width={video.width} />
                                                    )}

                                                    <PlayerPlayButton className='form-field-reset expand-interaction__action video-player-button'>
                                                        <span aria-label={t('Play video')}>
                                                            <IconDispatcher name='IconPlay' />
                                                        </span>
                                                    </PlayerPlayButton>
                                                </PlayerPlaceholder>
                                            </Player>
                                        </div>

                                        {caption && (
                                            <figcaption className='type-style-5 mt3'>
                                                {caption}
                                            </figcaption>
                                        )}
                                    </figure>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    caption    : PropTypes.string,
    posterImage: PropTypes.object,
    video      : PropTypes.object.isRequired,
};

Video.propTypes = propTypes;

export { Video };

export default Video;
